<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
  /** Quieter: a regular-weight base-size title, a heading-ink icon and a wider description (an empty section inside a screen, not a blank page). */
  quiet?: boolean;
}>();
</script>

<template>
  <div class="lumi-empty" :class="{ 'lumi-empty--quiet': quiet }">
    <div v-if="$slots.icon" class="lumi-empty__icon"><slot name="icon" /></div>
    <h4 class="lumi-empty__title">{{ title }}</h4>
    <p v-if="description" class="lumi-empty__desc">{{ description }}</p>
    <slot name="action" />
  </div>
</template>

<style>
.lumi-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:var(--space-12) var(--space-6);font-family:var(--font-body);}
.lumi-empty__icon{width:48px;height:48px;border-radius:var(--radius-md);background:var(--surface-wash);color:var(--text-secondary);display:flex;align-items:center;justify-content:center;margin-bottom:var(--space-4);}
.lumi-empty__icon svg{width:24px;height:24px;}
.lumi-empty__title{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-heading);margin:0 0 var(--space-1);}
.lumi-empty--quiet .lumi-empty__icon{color:var(--text-heading);}
.lumi-empty--quiet .lumi-empty__title{font-size:var(--text-base);font-weight:var(--weight-regular);}
.lumi-empty--quiet .lumi-empty__desc{max-width:48ch;}
.lumi-empty__desc{font-size:var(--text-sm);color:var(--text-secondary);max-width:36ch;margin:0 0 var(--space-4);}
</style>
